import {
    fetchAuthSession,
    getCurrentUser,
    signOut,
} from 'aws-amplify/auth';

export const isLogin = async () => {
    try {
        await getCurrentUser()
        return true;
    } catch (error) {
        // No current user, proceed with login
    }
    return false;
}

export const getUserGroups = async () => {
    const {
        tokens: session
    } = await fetchAuthSession();
    const groups = session?.accessToken.payload["cognito:groups"];
    return groups;
}

export const logout = async () => {
    await signOut();
}

export const clearLocalByPrefix = (prefix: string) => {
    const toDelete: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith(prefix)) toDelete.push(k);
    }
    toDelete.forEach(k => localStorage.removeItem(k));
}